module.exports = __webpack_public_path__ + "static/media/Lo_freq_strip.facc57cd.png";